import React from 'react';
import { faqs } from '../data/content';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

export const FAQSection = ({ showAll = false }) => {
  const displayFaqs = showAll ? faqs : faqs.slice(0, 2);

  return (
    <section data-testid="faq-section" className="section-spacing bg-gradient-to-b from-orange-50 to-white relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-yellow-500/10 rounded-full blur-3xl" />
      
      <div className="section-container relative z-10">
        {!showAll && (
          <div className="text-center max-w-2xl mx-auto mb-12">
            <span className="inline-block px-4 py-2 bg-yellow-100 text-yellow-700 rounded-full text-sm font-semibold mb-4">
              Questions?
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 font-['Outfit']">
              Frequently Asked <span className="text-coral">Questions</span>
            </h2>
            <p className="mt-4 text-slate-600 text-lg">
              Find answers to common questions about Apollo House.
            </p>
          </div>
        )}

        <div className="max-w-3xl mx-auto space-y-8">
          {displayFaqs.map((category) => (
            <div key={category.id} data-testid={`faq-category-${category.id}`}>
              <h3 className="text-xl font-bold text-slate-900 font-['Outfit'] mb-4">
                {category.category}
              </h3>
              <Accordion type="single" collapsible className="space-y-3">
                {category.questions.map((item, idx) => (
                  <AccordionItem
                    key={idx}
                    value={`${category.id}-${idx}`}
                    className="bg-white rounded-xl border border-orange-100 px-6 data-[state=open]:border-coral/30 data-[state=open]:shadow-md"
                  >
                    <AccordionTrigger
                      data-testid={`faq-question-${category.id}-${idx}`}
                      className="text-left font-semibold text-slate-900 hover:text-coral hover:no-underline py-4"
                    >
                      {item.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-slate-600 pb-4">
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
